module.exports = __webpack_public_path__ + "img/logo-footer-1.f812ec11.png";